export const defaultUserAccountData = {
    billing_data: {
        address: "",
        address2: "",
        city: "",
        name: "",
        state: "",
        country: "",
        zip: "",
        firstName: "",
        lastName: "",
    },
    cards: [{ brand: "", default: true, exp: "", img: "", last_four: "" }],
    email: "",
    phone: "",
    shipping_data: {
        address: "",
        address2: "",
        city: "",
        name: "",
        state: "",
        zip: "",
    },
    static_prefix: "",
    user_id: 0,
    firstName: "",
    lastName: "",
    name: "",
    giftCardBalance: 0,
    availablePointBalance: 0,
    pointsLoaded: 0,
    tier: "silver",
    actionsCompleted: {},
    actionHistory: [],
    slug: "",
    sheerIdVerified: false,
    tierProgress: {
        last_tier: 0,
        next_tier: 0,
        next_tier_name: "",
        progress: 0,
        show_progress: false,
    },
};
export function setCardDataArray(cards, currentCard, value) {
    const cardItemIndex = cards.findIndex((item) => currentCard.last_four === item.last_four && item.exp === currentCard.exp);
    const copyCard = { ...currentCard, default: value };
    const copyCardItems = [...cards].map((item) => ({ ...item, default: false }));
    copyCardItems[cardItemIndex] = copyCard;
    return { copyCardItems: copyCardItems.sort((a, b) => Number(b.default) - Number(a.default)), cardItemIndex };
}
export function setDeleteCardDataArray(cards, currentCard) {
    const cardItemIndex = cards.findIndex((item) => currentCard.last_four === item.last_four && item.exp === currentCard.exp);
    const copyCardItems = [...cards].filter((item) => item.last_four !== currentCard.last_four);
    return { copyCardItems, cardItemIndex };
}
export const validatePassword = (data) => {
    if (!data.new_password) {
        return "Enter new password";
    }
    if (!data.old_password) {
        return "Enter old password";
    }
    if (data.new_password !== data.new_password_confirm) {
        return "Passwords do not match";
    }
    if (data.new_password.length < 8) {
        return "Password must contain at least 8 symbols";
    }
    return "";
};
export const validatePhoneNumber = (string) => {
    const regex = /^([+]\d{2})?\d{10}$/;
    return regex.test(string);
};
